'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IcMore,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
} from '@musinsa/mds';
import type { MyCurationItem } from '@musinsa/services-curator';
import { CurationCopyShortLink } from './CurationCopyShortLink';
import { CurationDeleteButton } from './CurationDeleteButton';
import { CurationEditButton } from './CurationEditButton';
import { CurationOrderEditButton } from './CurationOrderEditButton';

interface Props {
  item: MyCurationItem;
  curationIndex: number;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const CurationTitleSectionIcMoreBottomSheet = ({
  item,
  curationIndex,
  open,
  onOpen,
  onClose,
}: Props) => (
  <Sheet direction="bottom" open={open}>
    <SheetTrigger asChild onClick={onOpen}>
      <IconButton size="size24x24">
        <IcMore />
      </IconButton>
    </SheetTrigger>
    <SheetPortal>
      <SheetContent onPointerDownOutside={onClose}>
        <SheetMotion direction="bottom">
          <BottomSheetTitle>
            <BottomSheetHandleArea />
            <BottomSheetTitleContainer className="py-[9px]!">
              <BottomSheetTitleBox>{item.title}</BottomSheetTitleBox>
              <IconButton size="size28x28" onClick={onClose}>
                <IcDelete />
              </IconButton>
            </BottomSheetTitleContainer>
          </BottomSheetTitle>
          <div className="flex flex-col px-4 bg-white safe-area-bottom">
            <CurationCopyShortLink
              curationId={item.curationId}
              curationIndex={curationIndex}
              curationType={item.type}
              onClose={onClose}
            />

            <CurationEditButton curationId={item.curationId} curationType={item.type} />

            <CurationOrderEditButton curationType={item.type} />

            <CurationDeleteButton
              title={item.title}
              curationId={item.curationId}
              curationType={item.type}
              onClose={onClose}
            />
          </div>
        </SheetMotion>
      </SheetContent>
      <SheetDimMotion>
        <Dim />
      </SheetDimMotion>
    </SheetPortal>
  </Sheet>
);
